import React from 'react';
import styles from './Resume.module.css';
import Products from './Products';

export default function Resume(props) {
  const { sharedStates, remoteStates, commands } = props;
  const {items, productsCounter, productsValue, deliveryValue, donationValue, distanceText} = sharedStates;
  
  return (
    <div className={styles.container}>
      <div className={styles.valuesBox}>
        <div className={styles.eachValueBox}>
          <p className={styles.productsAndDelivery}>Produtos ({productsCounter})</p>
          <p className={styles.productsAndDelivery}>{`+${productsValue.toFixed(2).toString().replace('.',',')}`}</p>
        </div>
        <div className={styles.eachValueBox}>
          <p className={styles.productsAndDelivery}>Entrega {distanceText ? `(${distanceText})`:''}</p>
          <p className={styles.productsAndDelivery}>{deliveryValue ? `+${(deliveryValue).toFixed(2).toString().replace('.',',')}`: 'Grátis'}</p>
        </div>
        <div className={styles.eachValueBox}>
          <p className={styles.donation}>Doações</p>
          <p className={styles.donation}>{`+${(donationValue || 0).toFixed(2).toString().replace('.',',')}`}</p>
        </div>
        <div className={styles.eachValueBox}>
          <p className={styles.total}>Total</p>
          <p className={styles.total}>{`+${(productsValue+ (deliveryValue || 0) + (donationValue || 0)).toFixed(2).toString().replace('.',',')}`}</p>
        </div>
      </div>
      <div className={styles.divisoryBox}>
        <div className={styles.divisoryLine}/>
      </div>
      { items.map((item, index)=>
      <Products key={index} sharedStates={item}/>
      )}
    </div>
  );
}
